namespace GeniuzPOS.InitialData {
    export interface PsPosStationRow {
        Id?: number;
        PosId?: string;
        PosPermitNo?: string;
        ShopId?: string;
        ShopFullName?: string;
        WhsId?: string;
        LastReceiptRunNo?: number;
        LastRefundRunNo?: number;
        CashierPosFg?: PsPosStationEnumCashierPosFg;
        PosScreenType?: string;
        PromptPayLink?: string;
        QRCodeAccount?: string;
        PosTouchPanelId?: string;
        MaxCashInDrawer?: number;
        AutoChargeFg?: PsPosStationEumAutoChargeFg;
        AutoChargeRate?: number;
        MandatorySalesmanFg?: PsPosStationEumMandatorySFg;
        MandatoryMemberFg?: PsPosStationEumMandatoryMFg;
        ConnectPrinterFg?: PsPosStationEumConnectPrinterFg;
        ConnectDrawerFg?: PsPosStationEumConnectDrawerFg;
        ConnectVfdFg?: PsPosStationEumConnectVFDFg;
        Connect2ndDispFg?: PsPosStationEumConnect2ndDispFg;
        ConnectEdcFg?: PsPosStationEumConnectEDCFg;
        ConnectRfidReaderFg?: PsPosStationEumConnectRFIDReaderFg;
        SellingPriceNo?: PsPosStationEunSellingPriceNo;
        PsParaDefault1?: boolean;
        ShopLogoOnFrontScreen?: string;
        ShopLogoOnReceipt?: string;
        RecptHeadMesg1?: string;
        RecptHeadMesg2?: string;
        RecptHeadMesg3?: string;
        RecptHeadMesg4?: string;
        RecptHeadMesg5?: string;
        RecptHeadMesg6?: string;
        RecptFootMesg1?: string;
        RecptFootMesg2?: string;
        RecptFootMesg3?: string;
        RecptFootMesg4?: string;
        RecptFootMesg5?: string;
        RecptFootMesg6?: string;
        RecptFootMesg7?: string;
        RecptFootMesg8?: string;
        RecptFootMesg9?: string;
        RecptFootMesg10?: string;
        RecptNoBarcodeFg?: Administration.PsParaGenTypeRecptNoBarcodeFg;
        PsParaDefault2?: boolean;
        SelectSellingPriceFg?: Administration.PsParaGenTypeSelectSellingPriceFg;
        ReceiptPrinterType?: Administration.PsParaGenTypeReceiptPrinterType;
        SalesDocFg?: Administration.PsParaGenTypeSalesDocFg;
        SalesVatType?: string;
        EjournalFg?: Administration.PsParaGenTypeEjournalFg;
        NoOfRecptCopy?: number;
        PrintOrderFg?: Administration.PsParaGenTypePrintOrderFg;
        PrintQueueFg?: Administration.PsParaGenTypePrintQueueFg;
        ItemOnRecptMethod?: Administration.PsParaGenTypeItemOnRecptMethod;
        RecptSumItemQtyFg?: Administration.PsParaGenTypeRecptSumItemQtyFg;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        ConnectEdcPort?: string;
        RecptHeadMesgFontSize?: number;
        RecptHeadMesgTextAlign?: number;
        RecptFootMesgFontSize?: number;
        RecptFootMesgTextAlign?: number;
        EdcBank?: string;
    }

    export namespace PsPosStationRow {
        export const idProperty = 'PosId';
        export const nameProperty = 'PosId';
        export const localTextPrefix = 'InitialData.PsPosStation';
        export const lookupKey = 'InitialData.PsPosStation';

        export function getLookup(): Q.Lookup<PsPosStationRow> {
            return Q.getLookup<PsPosStationRow>('InitialData.PsPosStation');
        }
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:เครื่องPOS:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:เครื่องPOS:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:เครื่องPOS:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:เครื่องPOS:Modify';

        export declare const enum Fields {
            Id = "Id",
            PosId = "PosId",
            PosPermitNo = "PosPermitNo",
            ShopId = "ShopId",
            ShopFullName = "ShopFullName",
            WhsId = "WhsId",
            LastReceiptRunNo = "LastReceiptRunNo",
            LastRefundRunNo = "LastRefundRunNo",
            CashierPosFg = "CashierPosFg",
            PosScreenType = "PosScreenType",
            PromptPayLink = "PromptPayLink",
            QRCodeAccount = "QRCodeAccount",
            PosTouchPanelId = "PosTouchPanelId",
            MaxCashInDrawer = "MaxCashInDrawer",
            AutoChargeFg = "AutoChargeFg",
            AutoChargeRate = "AutoChargeRate",
            MandatorySalesmanFg = "MandatorySalesmanFg",
            MandatoryMemberFg = "MandatoryMemberFg",
            ConnectPrinterFg = "ConnectPrinterFg",
            ConnectDrawerFg = "ConnectDrawerFg",
            ConnectVfdFg = "ConnectVfdFg",
            Connect2ndDispFg = "Connect2ndDispFg",
            ConnectEdcFg = "ConnectEdcFg",
            ConnectRfidReaderFg = "ConnectRfidReaderFg",
            SellingPriceNo = "SellingPriceNo",
            PsParaDefault1 = "PsParaDefault1",
            ShopLogoOnFrontScreen = "ShopLogoOnFrontScreen",
            ShopLogoOnReceipt = "ShopLogoOnReceipt",
            RecptHeadMesg1 = "RecptHeadMesg1",
            RecptHeadMesg2 = "RecptHeadMesg2",
            RecptHeadMesg3 = "RecptHeadMesg3",
            RecptHeadMesg4 = "RecptHeadMesg4",
            RecptHeadMesg5 = "RecptHeadMesg5",
            RecptHeadMesg6 = "RecptHeadMesg6",
            RecptFootMesg1 = "RecptFootMesg1",
            RecptFootMesg2 = "RecptFootMesg2",
            RecptFootMesg3 = "RecptFootMesg3",
            RecptFootMesg4 = "RecptFootMesg4",
            RecptFootMesg5 = "RecptFootMesg5",
            RecptFootMesg6 = "RecptFootMesg6",
            RecptFootMesg7 = "RecptFootMesg7",
            RecptFootMesg8 = "RecptFootMesg8",
            RecptFootMesg9 = "RecptFootMesg9",
            RecptFootMesg10 = "RecptFootMesg10",
            RecptNoBarcodeFg = "RecptNoBarcodeFg",
            PsParaDefault2 = "PsParaDefault2",
            SelectSellingPriceFg = "SelectSellingPriceFg",
            ReceiptPrinterType = "ReceiptPrinterType",
            SalesDocFg = "SalesDocFg",
            SalesVatType = "SalesVatType",
            EjournalFg = "EjournalFg",
            NoOfRecptCopy = "NoOfRecptCopy",
            PrintOrderFg = "PrintOrderFg",
            PrintQueueFg = "PrintQueueFg",
            ItemOnRecptMethod = "ItemOnRecptMethod",
            RecptSumItemQtyFg = "RecptSumItemQtyFg",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            ConnectEdcPort = "ConnectEdcPort",
            RecptHeadMesgFontSize = "RecptHeadMesgFontSize",
            RecptHeadMesgTextAlign = "RecptHeadMesgTextAlign",
            RecptFootMesgFontSize = "RecptFootMesgFontSize",
            RecptFootMesgTextAlign = "RecptFootMesgTextAlign",
            EdcBank = "EdcBank"
        }
    }
}
